import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 2H8C9.65 2 11 3.35 11 5V8C11 9.65 9.65 11 8 11H5C3.35 11 2 9.65 2 8V5C2 3.35 3.35 2 5 2ZM8 9C8.55 9 9 8.55 9 8V5C9 4.45 8.55 4 8 4H5C4.45 4 4 4.45 4 5V8C4 8.55 4.45 9 5 9H8ZM16 2H19C20.65 2 22 3.35 22 5V8C22 9.65 20.65 11 19 11H16C14.35 11 13 9.65 13 8V5C13 3.35 14.35 2 16 2ZM19 9C19.55 9 20 8.55 20 8V5C20 4.45 19.55 4 19 4H16C15.45 4 15 4.45 15 5V8C15 8.55 15.45 9 16 9H19ZM8 13H5C3.35 13 2 14.35 2 16V19C2 20.65 3.35 22 5 22H8C9.65 22 11 20.65 11 19V16C11 14.35 9.65 13 8 13ZM9 19C9 19.55 8.55 20 8 20H5C4.45 20 4 19.55 4 19V16C4 15.45 4.45 15 5 15H8C8.55 15 9 15.45 9 16V19ZM16 13H19C20.65 13 22 14.35 22 16V19C22 20.65 20.65 22 19 22H16C14.35 22 13 20.65 13 19V16C13 14.35 14.35 13 16 13ZM19 20C19.55 20 20 19.55 20 19V16C20 15.45 19.55 15 19 15H16C15.45 15 15 15.45 15 16V19C15 19.55 15.45 20 16 20H19Z"
  />,
  'Others'
)
